import { AdAccountFromApi } from 'shared/api/requests/ads/schema'

export const parseAccount = (item: AdAccountFromApi) => {
  return {
    ...item,
    id: item.account_id,
  }
}
